(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dps-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', function (event) {
    const detail = event.target;
    if (!(detail instanceof HTMLDetailsElement) || !detail.matches('.dps-menu') || !detail.open) return;
    detail.closest('.dps-navigation').querySelectorAll('.dps-menu[open]').forEach(function (other) { if (other !== detail) other.open = false; });
  }, true);
  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape' && event.code !== 'Escape') return;
    const detail = document.activeElement?.closest('.dps-menu[open]');
    if (!detail) return;
    detail.open = false;
    detail.querySelector('summary').focus();
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  const closeOutsideDesktopMenu = function (event) {
    document.querySelectorAll('.dps-navigation--desktop .dps-menu[open]').forEach(function (detail) {
      if (!detail.contains(event.target)) detail.open = false;
    });
  };
  document.addEventListener('click', closeOutsideDesktopMenu);
  document.addEventListener('focusin', closeOutsideDesktopMenu);
  } catch(e) { console.error(e); }
})();

})();
